import { LMconfig, ApiLMconfig, FieldDefaults } from "./types";
import { LMConfigResquest} from "./types"
import * as _ from "lodash";
import { format, parseISO, isValid } from "date-fns";

export const parseAPILMconfig = (apiLMconfig: ApiLMconfig): LMconfig => {
   
    const resultAPILMConfig = { ...apiLMconfig }
    const defaultFields = apiLMconfig.defaults?.fields;
    if (defaultFields) {
        const allDefaultFields = [...defaultFields];
        delete apiLMconfig['defaults'];
        delete resultAPILMConfig['defaults'];
        Object.keys(apiLMconfig).forEach(field => {
            const defaultForField = _.find(allDefaultFields, { name: field });
            if (defaultForField && _.isEmpty(apiLMconfig[field])) {
                resultAPILMConfig[field] = defaultForField.value
            }
        })
    }
    const result = {
        dealerId: resultAPILMConfig.iddealer,
        engineId: resultAPILMConfig.idengine,
        description: resultAPILMConfig.description,
        urlAppointment: resultAPILMConfig.appointmenturl,
        urlMenu: resultAPILMConfig.menuurl,
        urlOrder: resultAPILMConfig.placeorderlink,
        dateFirstOpened: resultAPILMConfig.datefirstopened,
        phone: resultAPILMConfig.phone,
        isPhoneDefaultFromCMS: Boolean(resultAPILMConfig.usecmsphone),
        phoneType: resultAPILMConfig.phoneType,
        businessName: resultAPILMConfig.businessName,
        businessNameType: resultAPILMConfig.businessNameType,
        trackingNumber: resultAPILMConfig.trackingNumber,
        trackingWebsiteUrl: resultAPILMConfig.trackingWebsiteUrl,
        customPhoneNumber: resultAPILMConfig.customPhoneNumber,
        customURL: resultAPILMConfig.customURL,
        customPhotoURL: {url: resultAPILMConfig.customPhotoURL, validation:[]},
        about: resultAPILMConfig.about,
        customBingPhoneNumber: resultAPILMConfig.customBingPhoneNumber,
        customBingURL: resultAPILMConfig.customBingURL,
        urlWebsite: resultAPILMConfig.websiteURL,
        urlWebsiteType: resultAPILMConfig.websiteURLType,
        address: resultAPILMConfig.address,
        addressType: resultAPILMConfig.addressType
    }
    return result;

}

export const parseLMConfigResquest = (lmConfig: LMconfig,field: string): LMConfigResquest => {
    return {
        fieldToValidate: field,
        data: parseUILMconfig(lmConfig)
    }
}

export const parseUILMconfig = (lmConfig: LMconfig): ApiLMconfig => {
    return {
        iddealer: lmConfig.dealerId ?? "",
        idengine: lmConfig.engineId ?? "",
        description: lmConfig.description ?? "",
        appointmenturl: lmConfig.urlAppointment ?? "",
        menuurl: lmConfig.urlMenu ?? "",
        placeorderlink: lmConfig.urlOrder ?? "",
        datefirstopened: lmConfig.dateFirstOpened ?? "",
        phone: lmConfig.phone ?? "",
        usecmsphone: lmConfig.isPhoneDefaultFromCMS,
        phoneType: lmConfig.phoneType??"",
        businessName: lmConfig.businessName??"",
        businessNameType: lmConfig.businessNameType??"",
        trackingNumber: lmConfig.trackingNumber??"",
        trackingWebsiteUrl: lmConfig.trackingWebsiteUrl??"",
        customPhoneNumber: lmConfig.customPhoneNumber??"",
        customURL: lmConfig.customURL??"",
        customPhotoURL: lmConfig.customPhotoURL?(lmConfig.customPhotoURL.url??""):"",
        about: lmConfig.about??"",
        customBingPhoneNumber: lmConfig.customBingPhoneNumber??"",
        customBingURL: lmConfig.customBingURL??"",
        websiteURL: lmConfig.urlWebsite??"",
        websiteURLType: lmConfig.urlWebsiteType??"",
        address: lmConfig.address,
        addressType: lmConfig.addressType
    }
}

export const URL_MAPPER = {
    "urlGeneric": "genericurl"
}

export const splitUrlComponents = (urlField: string, field: string, defaults?: FieldDefaults) => {
    const defaultValues = obtainValueFromDefaultsURL(field, defaults);
    if (urlField) {
        return breakURLIntoComponents(urlField, defaultValues.url, defaultValues.queryStringParameter)
    }
    return defaultValues;
}

export const obtainValueFromDefaultsURL = (field: string, defaults?: FieldDefaults) => {
    if (defaults && defaults.fields) {
        const defaultField = _.find(defaults.fields, { name: URL_MAPPER[field] });
        if (defaultField) {
            const defaultValue = defaultField.value;
            return breakURLIntoComponents(defaultValue);
        }
    }
    return {
        url: "",
        queryStringParameter: ""
    }
}

export const breakURLIntoComponents = (url: string, defaultUrl = "", defaultQueryStringParam = "") => {
    const components = url.split("?");
    return {
        url: components[0] ?? defaultUrl,
        queryStringParameter: components.length > 0 && components[1] ? `?${components[1]}` : defaultQueryStringParam
    }
}

export const parseStringDateToDate = (dateStr?: string) => {
    if (dateStr) {
        const dateComponents = dateStr.split("-");
        const year = parseInt(dateComponents[0])
        const month = parseInt(dateComponents[1])
        const day = parseInt(dateComponents[2]=='undefined'?'01':dateComponents[2]);
        const dateSanitized = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
        const dateCreated = parseISO(dateSanitized);
        if (isValid(dateCreated)) {
            return format(dateCreated, "LLLL do, yyyy")
        }
    }
    return ""
}

export const parseStringDateToDateObject = (dateStr: string) => {
    const dateComponents = dateStr.split("-");
    const year = parseInt(dateComponents[0])
    const month = parseInt(dateComponents[1])
    const day = parseInt(dateComponents[2]=='undefined'?'01':dateComponents[2]);
    const dateSanitized = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    const dateCreated = parseISO(dateSanitized);
    return dateCreated


}

export const parseHoursTo12Format = (openTime?: string, closeTime?: string) => {
    let openTimeFixed = "00:00 AM";
    let closeTimeFixed = "11:59 PM";
    if (openTime) {
      const openTimeConverted = convertTo12Format(openTime);
      if (openTimeConverted) openTimeFixed = openTimeConverted;
    }
    if (closeTime) {
      const closeTimeConverted = convertTo12Format(closeTime);
      if (closeTimeConverted) closeTimeFixed = closeTimeConverted;
    }
    return `${openTimeFixed} - ${closeTimeFixed}`;
}

export const convertTo12Format = (time: string) => {
  const splitedTime = time.split(":");
  if (splitedTime.length > 1) {
    let hourInt = parseInt(splitedTime[0]);
    let format = "AM";
    if (hourInt > 12) {
      hourInt -= 12;
      format = "PM";
    }else if(hourInt == 12){
      format = "PM";
    }
    return `${fillWithZeros(hourInt)}:${splitedTime[1]} ${format}`;
  }
  return undefined;
}

export const fillWithZeros = (numberInt: number, size?: number) => {
    if (!size) size = 2;
    let number = numberInt.toString();
    while (number.length < size) number = "0" + number;
    return number;
}

export const validateOnlyNumbers = (e: any) => {
  var theEvent = e || window.event;
  if (theEvent.type === 'paste') {
    key = theEvent.clipboardData.getData('text/plain');
  }
  else {
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  var regex = /^[0-9]*$/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export const validateHourFormat = (e: any) => {
  var theEvent = e || window.event;
  if (theEvent.type === 'paste') {
    key = theEvent.clipboardData.getData('text/plain');
  }
  else {
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  var regex = /^[0-9:]*$/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export const validateDateFormat = (e: any) => {
  var theEvent = e || window.event;
  if (theEvent.type === 'paste') {
    key = theEvent.clipboardData.getData('text/plain');
  }
  else {
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
  }
  let regex = new RegExp("^[0-9/]*$");
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export const fullDateRegex = (date?: string) => {
  var dateReg = new RegExp([
    '^(((0[13-9]|1[012])[-/]?(0[1-9]|[12][0-9]|30)',
    '|(0[13578]|1[02])[-/]?31|02[-/]?(0[1-9]|1[0-9]|2[0-8]))',
    '[-/]?[0-9]{4}|02[-/]?29[-/]?([0-9]{2}(([2468][048]|[02468][48])',
    '|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$',
  ].join(''));
  return date ? dateReg.test(date) : false;
}

export const validateInputDateFormat = (value: string) => {
  const date = value.split("/");
  if (!value || date.length <= 3 && (!date[0] || parseInt(date[0]) <= 12) && (!date[1] || parseInt(date[1]) <= 31) && (!date[2] || date[2].length <= 4)) {
      if (date.length === 3 && date[2].length === 4 && date.every(d => d !== "") && !date.some(d => d === '0')) {
        if (!fullDateRegex(date.map(d => String(d).padStart(2, "0")).join("/"))) return;
      }
      return value;
  }
  return;
}

export const regexHourFormat = (value?: string) => {
  if (value === undefined) return undefined;
  let stringMatch = value.match(/\b(?:[01][0-9]|2[0-3]):[0-5][0-9]\b/g);
  if (stringMatch?.length) return stringMatch[0]
  else return undefined;
}

export const getUtmParams = (lmpackage: string, location: string, defaults?: FieldDefaults) => {
    if (defaults && defaults.fields) {
        let parameterName =  (lmpackage==="ELITE" && location.includes("primary")) ? "eliteurl" : "genericurl";
        let fieldInfo : any = defaults.fields.find((field: any) => field.name===parameterName);
        return fieldInfo?.value??''
    }   
    else return ''; 
}